export default "__VITE_ASSET__DprbjiVA__";